<template>
    <div>
        <app-nav/>
        <main>
            <section>
                <div class="row d-flex justify-content-center m-0 p-0">
                    <div class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal mt-1 mb-4">
                                    {{ $t('Special offers') }}
                                </h1>
                            </div>
                        </div>
                        <ul class="nav nav-tabs justify-content-center" role="tablist">
                            <li v-for="(offer, i) in offers" class="nav-item" :key="i">
                                <a class="nav-link"
                                   :class="{ active: offer.slug[locale] === active_tab }"
                                   :id="offer.slug[locale]"
                                   data-toggle="tab"
                                   :href="`#${offer.slug[locale]}`"
                                   role="tab"
                                   :aria-controls="offer.slug[locale]"
                                   @click="changeTab(offer.slug[locale])"
                                   aria-selected="true">
                                    {{ $t(offer.name[locale]) }}
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="container mt-2">
                                <div v-for="(offer, i) in offers"
                                     class="tab-pane fade"
                                     :key="i"
                                     :class="{ 'show active': offer.slug[locale] === active_tab }"
                                     :id="offer.slug[locale]"
                                     role="tabpanel"
                                     :aria-labelledby="offer.slug[locale]">
                                    <app-card class="mb-3" v-if="offer.slug[locale] === active_tab">
                                        <template v-if="offer.dbname">
                                            <img :src="`${envUrl}/offers/${offer.dbname}`"
                                                 height="auto"
                                                 class="img-thumbnail rounded z-depth-1 w-100"/>
                                        </template>
                                        <div>
                                            <p v-if="offer.discount_percent">{{ $t('Discount') }}: -{{ offer.discount_percent }}%</p>
                                            <!--                                                <p>{{ $t('Period') }}: {{ offer.start_date | formatDate }} - {{ offer.end_date | formatDate }}</p>-->
                                            <div v-html="offer.comments[locale]"/>
                                        </div>
                                        <template v-if="offer.vehicles.length">
                                            <div class="mb-3" v-for="(vehicle, i) in offer.vehicles" :key="i">
                                                <div class="row">
                                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                                        <img
                                                            v-if="vehicle.imgs.length"
                                                            :src="`${envUrl}/vehicles/${vehicle.imgs[0].dbname}`"
                                                            height="auto"
                                                            class="img-thumbnail rounded z-depth-1 w-100"/>
                                                        <div v-else class="special-img rounded z-depth-1">
                                                            <div class="view car-img"/>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-5 col-md-6 col-sm-12">
                                                        <h4 class="dark-grey-text font-weight-normal">
                                                            {{ vehicle.make.name }} {{ vehicle.model.name }}
                                                        </h4>
                                                        <p class="dark-grey-text p-300-sm">
                                                            {{ $t(vehicle.transmission.name) }}
                                                            <br/>
                                                            {{ $t(vehicle.fuel.name) }}
                                                        </p>
                                                    </div>
                                                    <div class="col-lg-4 col-md-12 col-sm-12">
                                                        <div class="d-flex justify-content-center align-items-start">
                                                            <router-link
                                                                :to="{
                                                                    name: 'pub.booking',
                                                                    params: { vehicle_slug: vehicle.slug },
                                                                    query: { offer: offer.slug[locale] }
                                                                }"
                                                                class="btn btn-outline-autorent w-100">
                                                                {{ $t('Book now') }}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </app-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <app-footer/>
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicSpecialOfferService from '@services/publicSpecialOffer.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            active_tab: null,
            offers: []
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        getSpecialOffers() {
            PublicSpecialOfferService.getSpecialOffers().then(res => {
                this.offers = res;
                this.active_tab = res[0].slug[this.locale];
            });
        },
        changeTab(name) {
            this.active_tab = name;
        }
    },
    components: {
        AppNav,
        AppFooter
    },
    created() {
        this.getSpecialOffers();
    },
    metaInfo() {
        return {
            title: `${this.$t('Special offers')} | Autorent OÜ`
        };
    }
};
</script>
